export default function invalidFilter() {
    return record => record.hasErrors();
}
